export default __webpack_public_path__ + "static/media/connectionlost.d470fafd.png";